document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  let activeFilterValue = null;

  for (const [key, value] of params.entries()) {
    if (key.startsWith('filter.v.option.')) {
      activeFilterValue = value.toLowerCase();
      break;
    }
  }

  if (!activeFilterValue) return;

  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    const productDataEl = card.querySelector('[data-product-json]');
    if (!productDataEl) return;

    let product;
    try { product = JSON.parse(productDataEl.textContent); } catch (e) { return; }

    const matchingVariant = product.variants.find(function (v) {
      return v.options.some(function (o) {
        return o.toLowerCase() === activeFilterValue;
      });
    });

    if (!matchingVariant || !matchingVariant.featured_image) return;

    const img = card.querySelector('.card__media img');
    if (!img) return;

    const variantImg = matchingVariant.featured_image;
    img.src = variantImg.src;
    img.srcset = '';
  });
});
